import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import type { Instrumentation } from '@opentelemetry/instrumentation';

import { OtelInstrumentationService, SPAN_CONSOLE_EXPORTER } from './otel-instrumentation.service';
import { traceStateInterceptor } from './trace-state.interceptor';

export interface TracingConfigOptions {
    /**
     * For debugging purposes, log all spans in the console.
     */
    logSpanInConsole?: boolean;
    instrumentations?: Instrumentation[];
}

export function provideTracing(config?: TracingConfigOptions): EnvironmentProviders {
    return makeEnvironmentProviders([
        OtelInstrumentationService,
        { provide: SPAN_CONSOLE_EXPORTER, useValue: config?.logSpanInConsole },
        provideHttpClient(withInterceptors([traceStateInterceptor()])),
        provideEnvironmentInitializer(() => inject(OtelInstrumentationService).start(config?.instrumentations))
    ]);
}
